<nz-tabset
  *ngIf="
    annexes?.length &&
    (countries$ | async)?.length &&
    (voivodeships$ | async)?.length &&
    (specialities$ | async)?.length
  "
  [(nzSelectedIndex)]="selectedAnnexIndex"
  nzType="editable-card"
  class="additional-class"
  (nzAdd)="createAnnex()">
  <ng-container *ngFor="let annex of annexes; index as annexIndex">
    <ng-template #tabTitle>
      {{ tabNameByAnnexId[annex.id] || '' }}
    </ng-template>

    <ng-template #deleteEntity>
      <button
        type="button"
        class="delete-annex-button"
        (click)="removeAnnex(annex)"
        [attr.aria-label]="'COMMON.ACTION.DELETE' | translate">
        <span nz-icon nzType="delete" nzTheme="outline" [attr.aria-hidden]="true"></span>
      </button>
    </ng-template>

    <nz-tab
      [nzTitle]="tabTitle"
      nzClosable
      [nzCloseIcon]="deleteEntity"
      [attr.aria-current]="selectedAnnexIndex === annexIndex ? 'page' : null">
      <app-annex-form
        [userProcess]="userProcess"
        [annex]="annex"
        (annexChanged)="annexChanged($event)"
        [voivodeships]="voivodeships$ | async"
        [countries]="countries$ | async"
        [specialities]="specialities$ | async">
      </app-annex-form>
    </nz-tab>
  </ng-container>
</nz-tabset>

<nz-empty
  *ngIf="(loading$ | async) === false && annexes?.length === 0"
  [nzNotFoundContent]="contentTpl"
  [nzNotFoundFooter]="footerTpl"
  nzNotFoundImage="simple"
  aria-labelledby="annex-empty-title"
  role="region">
  <ng-template #contentTpl>
    <span>{{ 'ANNEX.NO_ENTITIES_ADDED_IN_ANNEX1' | translate }}</span>
  </ng-template>
  <ng-template #footerTpl>
    <button nz-button nzType="primary" (click)="createAnnex()">
      {{ 'ANNEX.CREATE_NEW_ENTITY' | translate }}
    </button>
  </ng-template>
</nz-empty>

<div
  *ngIf="(loading$ | async) || (loadingV$ | async) || (loadingC$ | async) || (loadingS$ | async)"
  class="loading-wrapper"
  role="status"
  aria-live="polite">
  <span class="sr-only">
    {{ 'COMMON.LAYOUT.LOADING' | translate }}
  </span>

  <mat-spinner id="updateIndicatorLoading" [diameter]="50" [attr.aria-hidden]="true"> </mat-spinner>
</div>
